import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { pageWithPayloadAndQuery } from "../../../../redux/actions/Page";
import { orgIdSelector } from "../../../../selectors/orgIdSelector";

/*
Component
*/

const TableContainer = (props) => {
  const {
    dispatchFetchData,
    getRows,
    gotoIp,
    logdevId,
    orgId,
    refresh,
    selectedInterval,
    Table,
    tableData,
  } = props;

  useEffect(() => {
    if (logdevId && orgId && selectedInterval) {
      dispatchFetchData({
        logdevId,
        orgId,
        selectedInterval,
      });
    }
  }, [dispatchFetchData, logdevId, orgId, refresh, selectedInterval]);

  const onClickIp = (ipId) => (evt) => {
    evt.stopPropagation();

    gotoIp({ ipId, orgId });
  };

  const rows = getRows({
    data: tableData,
    onClickIp,
  });

  if (!rows.length) {
    return null;
  }

  return (
    <div>
      <Table data={rows} />
    </div>
  );
};

TableContainer.propTypes = {
  dispatchFetchData: PropTypes.func.isRequired,
  getRows: PropTypes.func.isRequired,
  gotoIp: PropTypes.func,
  logdevId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  orgId: PropTypes.string.isRequired,
  refresh: PropTypes.bool,
  selectedInterval: PropTypes.shape({}).isRequired,
  Table: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.node,
  ]).isRequired,
  tableData: PropTypes.arrayOf(PropTypes.shape({})),
};

TableContainer.defaultProps = {
  gotoIp: () => {},
  refresh: false,
  tableData: [],
};

const makeMapStateToProps = (
  _,
  { dataSelector, idSelector, intervalSelector }
) => {
  const mapStateToProps = (state) => {
    const tableData = dataSelector(state);

    const orgId = orgIdSelector(state);

    const logdevId = idSelector(state);

    const selectedInterval = intervalSelector(state);

    return {
      logdevId,
      orgId,
      selectedInterval,
      tableData,
    };
  };

  return mapStateToProps;
};

const makeMapDispatchToProps = (_, { fetchData }) => {
  const mapDispatchToProps = (dispatch) => ({
    dispatchFetchData: ({
      logdevId,
      orgId,
      pageNum,
      pageSize,
      selectedInterval,
    }) => {
      dispatch(
        fetchData({
          logdevId,
          orgId,
          pageNum,
          pageSize,
          selectedInterval,
        })
      );
    },

    gotoIp: ({ ipId, orgId }) => {
      const payload = {
        orgId,
        toplevel: "investigate",
        secondlevel: "ips",
        id1: ipId,
      };

      dispatch(
        pageWithPayloadAndQuery({
          payload,
          query: {},
        })
      );
    },
  });

  return mapDispatchToProps;
};

// Default export
const TableContainerConnected = connect(
  makeMapStateToProps,
  makeMapDispatchToProps
)(TableContainer);

export default TableContainerConnected;
